import {useEffect, useState} from 'react'
import { MenuComponent } from '../../../../../_metronic/assets/ts/components'
import { initialQueryState,KTIcon } from '../../../../../_metronic/helpers'
import { useQueryRequest } from '../../accounts/Users/core/QueryRequestProvider'
import { useQueryResponse } from '../../../apps/user-management/users-list/core/QueryResponseProvider'

const DateTimeFilter = (props:any) => {
  const {updateState} = useQueryRequest()
  const {isLoading} = useQueryResponse()
  const [vacio,setvacio]=useState(false)


  const resetData = () => {
    props.setValueFecha('')
    props.setEndFecha('')
    setvacio(true)
  }
  console.log(vacio)
  useEffect(()=>{
    if(vacio==true){
      props.fetchRecords()
    }

  },[vacio])


  return (
    <>
      {/* begin::Filter Button */}
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-marino me-3'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <KTIcon iconName='calendar' className='fs-2' />
        Filter by date
      </button>
      {/* end::Filter Button */}
      {/* begin::SubMenu */}
      <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px' data-kt-menu='true'>
        {/* begin::Header */}
        <div className='px-7 py-5'>
          <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
        </div>
        {/* end::Header */}

        {/* begin::Separator */}
        <div className='separator border-gray-200'></div>
        {/* end::Separator */}

        {/* begin::Content */}
        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          {/* begin::Input group */}
          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>Start Datetime</label>
            <input
                id="party"
                type="datetime-local"
                name="partydate" 
                className='form-control form-control-solid border-marino text-parrafo'
                onChange={(e) => props.setValueFecha(e.target.value)}
                value={props.valueFecha}
            />
          </div>
          {/* end::Input group */}

          {/* begin::Input group */}
          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>End Datetime</label>
            <input
                        id="party"
                        type="datetime-local"
                        name="partydate" 
                        className='form-control form-control-solid border-marino text-parrafo '
                        onChange={(e) => props.setEndFecha(e.target.value)}
                        value={props.EndFecha}
                    />
            </div>
          {/* end::Input group */}

          {/* begin::Actions */}
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              disabled={isLoading}
              onClick={resetData}
              className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
              data-kt-menu-dismiss='true'
            >
              Reset
            </button>

            <button
              disabled={isLoading}
              type='button'
              onClick={()=>(props.fetchRecords(),setvacio(false))}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
            >
              Apply
            </button>
          </div>
          {/* end::Actions */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::SubMenu */}
    </>
  )
}

export {DateTimeFilter}